import React, { useEffect } from 'react';
import * as apiMethods from '../res/apiMethods.js';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DownloadIcon from '@mui/icons-material/Download';

const Debug = () => {
  useEffect(() => {
    const token = window.sessionStorage.getItem('localToken');
    const username = window.sessionStorage.getItem('username');
    if (!token) { window.location.href = '/login'; return; }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!(payload.roleId === 1 && username === 'complemento360')) {
        window.location.href = '/access-denied';
        return;
      }
    } catch {
      window.location.href = '/accessDenied';
      return;
    }
  }, []);

  const handleCheckMoraUVR = async () => {
    try {
      const token = window.sessionStorage.getItem('localToken');
      const response = await fetch(apiMethods.CHECK_MORA_UVR, {
        headers: { Authorization: token }
      });
      if (!response.ok) throw new Error('Error al descargar');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `check-mora-uvr_${new Date().toISOString().slice(0, 10)}.txt`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error descargando reporte mora UVR:', err);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', maxWidth: '1000px', margin: '0 auto' }}>
      {/* Header */}
      <div className="section-header">
        <div className="title-group">
          <h1>Herramientas de Diagnóstico & Debug</h1>
          <p>Utilidades avanzadas de verificación de consistencia contable y salud de la base de datos (Superadmin)</p>
        </div>
      </div>

      {/* Card: Verificación Mora UVR */}
      <div className="glass-panel" style={{ padding: '2rem 2.25rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem' }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '14px',
            background: 'rgba(215, 25, 32, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#D71920'
          }}>
            <AssessmentIcon style={{ fontSize: '1.6rem' }} />
          </div>
          <div>
            <h3 style={{ fontSize: '1.15rem', fontWeight: 700, margin: 0, color: '#101828' }}>
              Verificación de Integridad de Mora UVR
            </h3>
            <p style={{ fontSize: '0.84rem', color: '#667085', margin: '2px 0 0 0' }}>
              Comprueba si existen créditos UVR con valor de mora en pesos positivo y contraparte en UVR en cero.
            </p>
          </div>
        </div>

        <div style={{
          background: '#F8FAFC',
          padding: '1.1rem 1.35rem',
          borderRadius: '12px',
          border: '1px solid #E2E8F0',
          fontSize: '0.86rem',
          color: '#475467',
          lineHeight: 1.55
        }}>
          Regla de consistencia: <code style={{ color: '#D71920', fontWeight: 600 }}>vlrAplicadoIntMora &gt; 0 &amp;&amp; vlrAplicadoIntMoraUVR == 0</code>.
          <br />
          Descarga un archivo <strong>.txt</strong> detallando los créditos identificados con discrepancias para auditoría contable.
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-start', paddingTop: '0.25rem' }}>
          <button
            type="button"
            className="btn-mobilia-primary"
            onClick={handleCheckMoraUVR}
          >
            <DownloadIcon style={{ fontSize: '1.05rem' }} />
            Descargar Reporte Mora UVR (.txt)
          </button>
        </div>
      </div>
    </div>
  );
};

export default Debug;
